/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Features_Booking_CtaInputs */

const en_features_booking_cta = /** @type {(inputs: Features_Booking_CtaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Book ${i?.time}`)
};

const pl_features_booking_cta = /** @type {(inputs: Features_Booking_CtaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rezerwuj ${i?.time}`)
};

/**
* | output |
* | --- |
* | "Book {time}" |
*
* @param {Features_Booking_CtaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_booking_cta = /** @type {((inputs: Features_Booking_CtaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Booking_CtaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_booking_cta(inputs)
	return en_features_booking_cta(inputs)
});